import {
  Dataviz,
  DatavizName,
  getDefaultDataviz,
} from "@radarly/models/dataviz";
import { EmptyFragment } from "@radarly/models/search";
import { isEmbeddedCardDataviz } from "../dataviz";
import { Card, EmbeddedCard } from "../model";
import { CardFactory, CardFragmentsFactory } from "./base";
import { ICardFactory } from "./model";

export class EmbeddedCardFragmentsFactory extends CardFragmentsFactory {
  static create() {
    const factory = new EmbeddedCardFragmentsFactory();
    return factory.getFragment();
  }
  private getFragment(): EmptyFragment {
    return [];
  }
}

export class EmbeddedCardFactory
  implements ICardFactory<EmbeddedCard, Record<string, unknown>>
{
  public static getInstance() {
    return new EmbeddedCardFactory();
  }
  public fromCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    input?: { dataviz?: Dataviz }
  ) {
    return CardFactory.getInstance<EmbeddedCard>().createCard(
      workspaceId,
      projectFocuses,
      "embedded",
      card.title,
      EmbeddedCardFragmentsFactory.create(),
      this.createDataviz(input?.dataviz || card.dataviz)
    );
  }
  public fromInput(
    workspaceId: number,
    projectFocuses: number[],
    title: string,
    input?: { dataviz?: Dataviz["name"]; fullDataviz?: Dataviz }
  ) {
    return CardFactory.getInstance<EmbeddedCard>().createCard(
      workspaceId,
      projectFocuses,
      "embedded",
      title,
      EmbeddedCardFragmentsFactory.create(),
      this.createDataviz(
        input?.fullDataviz ??
          getDefaultDataviz(input?.dataviz || DatavizName.Embedded)
      )
    );
  }
  public createDataviz(dataviz: Dataviz) {
    if (isEmbeddedCardDataviz(dataviz)) {
      return dataviz;
    } else {
      return getDefaultDataviz(DatavizName.Embedded) as EmbeddedCard["dataviz"];
    }
  }
}
